<script setup>
import {computed} from "vue";

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
})

const mainWebsite = computed(() => props.ticket.websites[0] ?? {})
</script>

<template>
  <div>
    {{ ticket.subject }}
    <br>
    <small :class="{'text-muted': mainWebsite?.is_deleted}">
      <span
        class="xs-mr-10"
        :class="{'text-muted': mainWebsite?.organisation?.is_deleted}"
      >
        <i class="fas fa-building" />
        {{ mainWebsite?.organisation?.name }}
        <span v-if="mainWebsite?.organisation?.is_deleted">(Deleted)</span>
      </span>

      <span class="xs-mr-10">
        <i class="fas fa-link" />
        {{ mainWebsite?.simple_url }}
        <span v-if="mainWebsite?.is_deleted">(Deleted)</span>
      </span>

      <span
        v-if="ticket.impacts_new_customer"
        class="new-customer rounded-pill px-2 py-1 text-white flex-shrink-0"
      >
        New Customer
      </span>
    </small>
  </div>
</template>

<style>
.new-customer {
  background-color: #BC8CFF;
}
</style>

